import React, { useEffect, useState } from "react";
import style from "../CommonStyles/commonformstyles.module.scss";
import LinearProgressBar from "../../../../components/ProgressBar/LinearProgressBar";
import { GoTrash } from "react-icons/go";
import { FaCloudArrowUp, FaPlus } from "react-icons/fa6";
import useMultipleFileUploadAws from "../../../../hooks/AWSFileUpload/useMultipleFileUploadAws";

const ServiceGalleryForm = ({ formData, setFormData, handleNext }) => {
  const [selectedFiles, setSelectedFiles] = useState(formData.gallery?.mediaFiles || []);
  const [localFiles, setLocalFiles] = useState([]);

  const { uploadFileToS3, cancelUpload, mediaUrls, uploadProgresses } =
    useMultipleFileUploadAws();

  useEffect(() => {
    // Update form data when mediaUrls change
    const uploadedFiles = localFiles
      .filter(file => mediaUrls[file.name])
      .map(file => ({
        url: mediaUrls[file.name],
        type: file.type,
        name: file.name
      }));

    if (uploadedFiles.length > 0 || selectedFiles.length > 0) {
      setFormData(prevData => ({
        ...prevData,
        gallery: {
          mediaFiles: [...selectedFiles, ...uploadedFiles],
          youtubeLink: prevData.gallery?.youtubeLink || [{ link: "" }],
        },
      }));
    }
  }, [mediaUrls, localFiles, selectedFiles, setFormData]);

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);

    if (files.length + localFiles.length + selectedFiles.length > 5) {
      alert("You can only upload up to 5 files!");
      return;
    }

    const oversizedFiles = files.filter(file => file.size > 1024 * 1024 * 1024);
    if (oversizedFiles.length > 0) {
      alert("Each file must be less than 1GB!");
      return;
    }

    const newFiles = files.filter(
      file => !localFiles.some(f => f.name === file.name) && 
              !selectedFiles.some(f => f.name === file.name)
    );

    if (newFiles.length > 0) {
      setLocalFiles(prev => [...prev, ...newFiles]);
      newFiles.forEach(file => uploadFileToS3(file));
    }
    
    // Reset the input value to allow selecting the same file again if needed
    e.target.value = null;
  };

  const handleCancelUpload = (fileName) => {
    // Remove from local files if not yet uploaded
    setLocalFiles(prev => prev.filter(file => file.name !== fileName));
    
    // Remove from selected files if already part of formData
    setSelectedFiles(prev => prev.filter(file => file.name !== fileName));
    
    cancelUpload(fileName);
  };

  // Check if all files are uploaded
  const allFilesUploaded = localFiles.every(file => mediaUrls[file.name]);
  const uploadComplete = (selectedFiles.length > 0 || localFiles.length > 0) && 
                       (localFiles.length === 0 || allFilesUploaded);

  return (
    <div className={style.serviceGallery}>
      <h2 className={style.dashboardFormContinerHeadingService}>
        Service Assets
      </h2>

      <div className={style.fileUploadContainer}>
        <h3 className={style.labels}>Upload Image / Video</h3>

        <div
          className={style.DragUploader}
          onDragOver={(e) => e.preventDefault()}
        >
          <div className={style.DragUploaderImageContainer}>
            {localFiles.length === 0 && selectedFiles.length === 0 ? (
              <>
                <FaCloudArrowUp className={style.uploadIcon} />
                <p className={style.uploadText}>Drop files here</p>
                <p className={style.supportedFormats}>
                  Supported: PNG, JPG, MP4, WEBM
                </p>
                <p className={style.orText}>OR</p>
                <h2
                  className={style.browseText}
                  onClick={() => document.getElementById("file-input").click()}
                >
                  <strong>Browse Files</strong>
                </h2>
              </>
            ) : (
              <>
                {selectedFiles.map((file) => (
                  <div key={file.name} className={style.filePreview}>
                    {file.type.startsWith("image/") ? (
                      <img
                        src={file.url}
                        alt="Preview"
                        className={style.imagePreview}
                      />
                    ) : (
                      <video width="100%" height="80px" controls>
                        <source src={file.url} type={file.type} />
                        Your browser does not support videos.
                      </video>
                    )}
                    <GoTrash
                      onClick={() => handleCancelUpload(file.name)}
                      className={style.deleteIcon}
                    />
                  </div>
                ))}
                
                {localFiles.map((file) => (
                  <div key={file.name} className={style.filePreview}>
                    {file.type.startsWith("image/") ? (
                      <img
                        src={URL.createObjectURL(file)}
                        alt="Preview"
                        className={style.imagePreview}
                      />
                    ) : (
                      <video width="100%" height="80px" controls>
                        <source src={URL.createObjectURL(file)} type={file.type} />
                        Your browser does not support videos.
                      </video>
                    )}
                    <GoTrash
                      onClick={() => handleCancelUpload(file.name)}
                      className={style.deleteIcon}
                    />
                    <LinearProgressBar
                      progress={uploadProgresses[file.name] || 0}
                      bgColor="#7F55E0FF"
                      height="6px"
                    />
                  </div>
                ))}

                {(localFiles.length + selectedFiles.length) < 5 && (
                  <div 
                    className={style.addMoreMedia} 
                    onClick={() => document.getElementById("file-input").click()}
                  >
                    <FaPlus className={style.plusIcon} />
                    <span>Add Media</span>
                  </div>
                )}
              </>
            )}

            <input
              id="file-input"
              type="file"
              accept="image/png, image/jpeg, video/mp4, video/webm"
              className={style.fileInput}
              onChange={handleFileUpload}
              multiple
              hidden
            />
          </div>
        </div>
      </div>

      <div className={style.formButtonsContainer}>
        <button
          className={style.dashboardFormSaveButtonDown}
          onClick={handleNext}
          disabled={!uploadComplete}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ServiceGalleryForm;